import { z } from "zod";

export const profileSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, "Enter your first name")
    .max(80, "Keep this under 80 characters"),
  lastName: z
    .string()
    .trim()
    .min(1, "Enter your last name")
    .max(80, "Keep this under 80 characters"),
});

export type ProfileValues = z.infer<typeof profileSchema>;
